import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import CarTileGridSkeleton from '../../../components/car-tile/car-tile-grid-skeleton';
import type { ModuleSkeletonProps } from '../../../vars';

export default function FahrzeugsucheListSidebarSkeleton(props: ModuleSkeletonProps) {
    const { settings } = props;

    return (
        <Stack gap={2}>
            <Stack direction="row" justifyContent="space-between">
                <Skeleton variant="text" sx={{ width: 150 }} />
                <Stack direction="row" gap={2} justifyContent="flex-end">
                    <Skeleton variant="rounded" sx={{ height: 35, width: 150 }} />
                    <Skeleton variant="text" sx={{ width: 200 }} />
                    <Skeleton variant="text" sx={{ width: 100 }} />
                </Stack>
            </Stack>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, lg: 3 }}>
                    <Stack spacing={2} justifyContent="space-between">
                        <Stack gap={2}>
                            <Skeleton variant="rounded" sx={{ height: 57.5, width: '100%' }} />
                        </Stack>
                        <Divider />
                        <Stack gap={2}>{settings?.fahrzeugsuche?.filter?.sidebar?.map((key) => <Skeleton key={key} variant="rounded" sx={{ height: 57.5, width: '100%' }} />)}</Stack>
                    </Stack>
                </Grid>
                <Grid container spacing={2} size={{ xs: 12, lg: 9 }}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <CarTileGridSkeleton />
                    </Grid>
                </Grid>
            </Grid>
        </Stack>
    );
}
